import { render, staticRenderFns } from "./EpicContent.vue?vue&type=template&id=8ab5445e&scoped=true&"
import script from "./EpicContent.vue?vue&type=script&lang=ts&"
export * from "./EpicContent.vue?vue&type=script&lang=ts&"
import style0 from "./EpicContent.vue?vue&type=style&index=0&id=8ab5445e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab5445e",
  null
  
)

export default component.exports